define('drops/filter/filter',["jquery", "underscore", "lq/drop", "lq/dispatcher", "lq/types", "lq/style", "lq/parameterBinding"], function (
    $,
    _,
    Drop,
    dispatcher,
    types,
    Style,
    parameterBinding,
) {
    "use strict";

    var defaults = {
        data: {},
    };

    var Filter = function (options) {
        Drop.call(this, $("<div/>"), defaults, options);

        Style.renderStyles(this);
    };

    Drop.extend(Filter, Drop);

    Filter.typeName = "Filter";

    Filter.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    Filter.prototype.render = function ($element) {
        return this.createAndRenderDrops($element);
    };

    Filter.prototype.postRender = function () {
        // Extend the filters with the runtime drop references
        this.filtersById = {};

        if (!this.data.filters) return;
        
        for (var i = 0; i < this.data.filters.length; i++) {
            var filter = this.data.filters[i];
            var drop = this.piping.dropFactory.findDropById(filter.id);

            if (!drop) continue;

            this.filtersById[filter.id] = {
                ...filter,
                drop,
            };
        }
    };

    Filter.prototype.createRenderPromiseForChild = function (drop) {
        return drop.render(this.$element);
    };

    Filter.prototype.licquidMethod_filter = function () {
        var self = this;

        _.each(Object.keys(this.filtersById), function (filterId) {
            var filter = self.filtersById[filterId];
            var value = filter.drop.getValue();

            self.mapValueToParameter(filter, value);
        });
    };

    Filter.prototype.licquidMethod_clear = function () {
        var self = this;

        _.each(Object.keys(this.filtersById), function (filterId) {
            var filter = self.filtersById[filterId];
            if (filter.drop.clearValue) filter.drop.clearValue();
        });
    };

    Filter.prototype.licquidMethod_reset = function () {
        var self = this;

        _.each(Object.keys(this.filtersById), function (filterId) {
            var filter = self.filtersById[filterId];
            if (filter.drop.clearValue) filter.drop.clearValue();

            self.mapValueToParameter(filter, filter.drop.getValue());
        });

        this.deleteFilterData();
    };

    Filter.prototype.licquidMethod_discard = function () {
        var self = this;

        _.each(Object.keys(this.filtersById), function (filterId) {
            var filter = self.filtersById[filterId];
            self.mapValueFromParameter(filter);
        });
    };

    Filter.prototype.licquidMethod_load = function () {
        var self = this;
        
        var payload = {
            actionId: this.piping.actionId,
            morphId: this.data.id
        };

        // Due to key casing being jumbled by the backend, use case insensitive matching
        var findFilter = function (incomingKey) {
            var id = _.find(Object.keys(self.filtersById), function (id) {
                return self.filtersById[id].entityAttribute.toLowerCase() === incomingKey.toLowerCase();
            });
            return id ? self.filtersById[id] : undefined;
        };

        dispatcher.dispatch("Entity/LoadFilterData", payload, function (response) {
            if (!response || !response.values) return;

            // response.values is a dictionary of filters in the form of key (attribute): value (stored filter value)
            _.each(Object.keys(response.values), function (key) {
                var value = response.values[key];
                if (!value) return;

                var filter = findFilter(key);
                if (!filter) return;

                self.mapValueToParameter(filter, value);
                if (filter.drop) filter.drop.setValue({ type: types.getTypeOfValue(value), value: value });
            });
        });
    };

    Filter.prototype.licquidMethod_save = function () {
        if (!this.data.filters || this.data.filters.length === 0) return [];

        var self = this;
        var values = _.filter(
            _.map(Object.keys(this.filtersById), function (filterId) {
                var filter = self.filtersById[filterId];

                if (!filter) return null;

                var attribute = filter.entityAttribute;

                if (!attribute) return null;

                var value = filter.drop.getValue() || "";
                value = value.toString();

                return {
                    key: attribute,
                    value: value,
                };
            }),
            function (item) {
                return item !== null;
            },
        );

        var payload = {
            actionId: this.piping.actionId,
            morphId: this.data.id,
            values: values,
        };

        dispatcher.dispatch("Entity/SaveFilterData", payload);
    };

    Filter.prototype.deleteFilterData = function () {
        var payload = {
            actionId: this.piping.actionId,
            morphId: this.data.id,
        };

        dispatcher.dispatch("Entity/DeleteFilterData", payload);
    };

    // Parameters

    Filter.prototype.mapValueToParameter = function (filter, value) {
        if (!this.hasValidParameter(filter)) return;

        this.piping.parameters.locals.setValue(filter.parameter.name, value);
    };

    Filter.prototype.mapValueFromParameter = function (filter) {
        if (!this.hasValidParameter(filter)) return;

        var value = this.piping.parameters.locals.getValue(filter.parameter.name);
        filter.drop.setValue({ value });
    };

    Filter.prototype.hasValidParameter = function (filter) {
        // Check if parameter exists and have a value
        if (!filter.parameter || !filter.parameter.name) {
            return false;
        }

        return true;
    };

    return Filter;
});

